import { InputData } from "../input/InputData";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { PHPResponse } from "../PHPResponse";
import { CartEntryListResponse } from "./CartEntryListResponse";
import { CartListInput } from "./CartListInput";

export class CartItemInput extends CartListInput
{
  id:string;
}
